<template>
  <section :id="uid" class="content-section" :class="uid" :data-url="page.url">
    <div class="content-section__preview" v-html="page.preview_text"></div>
    <router-link v-if="page.text" :to="{ path: getPath(page.url) }" class="full-content-link d-flex mt-6 text--medium no-underline"><arrow/><i class="pl-2">READ MORE</i></router-link>
    <!-- <ul class="subpage-list text--medium mt-5" v-if="subpages && subpages.length">
      <li v-for="subpage in subpages" v-if="subpage.visible" :key="subpage.uid" class="mb-6">
        <div class="text--title-medium"><i>{{ subpage.title }}</i></div>
        <div v-if="subpage.author" class="subpage--author">by {{ subpage.author }}</div>
        <div v-if="subpage.subtitle" class="text--title-italics-medium text--uppercase"><i>{{ subpage.subtitle }}</i></div>
        <router-link class="no-underline" :to="{ path: getPath(subpage.url) }"><arrow class="mr-2"/><i>READ</i></router-link>
        <hr/>
      </li>
    </ul> -->
    <hr/>
  </section>
</template>

<script>
import Arrow from '@/components/Arrow'
import { getPath } from '@/util'

export default {
  name: 'content-section',
  props: {
    uid: {
      type: String
    }
  },
  components: {
    Arrow
  },
  data () {
    return {
    }
  },
  computed: {
    page () {
      return this.$store.getters.getPageByUID(this.uid)
    },
    subpages () {
      // subsections ar listd below
      // sections are listed after content
      return this.page.children
    }
  },
  methods: {
    getPath
  }
}
</script>
<style lang="stylus">
.content-section__preview > h1:first-child,
.content-section__preview > h2:first-child
  margin-top 0
</style>
